import { render, staticRenderFns } from "./InitiateRegistrationModal.vue?vue&type=template&id=339a75b4&"
import script from "./InitiateRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./InitiateRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports